module.exports = __webpack_public_path__ + "img/bringg-logo-small.ce411ce5.svg";